import React, { useEffect, useState } from "react";
import { MousePointerClick } from "lucide-react";
import { apiClient } from "@/lib/auth";

const SOURCES = [["menu", "Top menu"], ["hero", "Banner button"], ["footer", "Footer"]];

export default function DemoClicksCard() {
  const [s, setS] = useState(null);
  useEffect(() => {
    apiClient.get("/admin/demo-clicks/stats").then(({ data }) => setS(data)).catch(() => setS(false));
  }, []);
  if (s === false) return null;
  const diff = s ? s.this_week - s.last_week : 0;
  return (
    <div className="nds-card p-5" data-testid="demo-clicks-card">
      <div className="flex items-start justify-between">
        <div className="nds-label">Live Demo taps · this week</div>
        <div className="w-9 h-9 grid place-items-center bg-nex-navy text-nex-goldbright rounded-sm">
          <MousePointerClick className="w-4 h-4" strokeWidth={1.8} />
        </div>
      </div>
      <div className="mt-4 flex items-baseline gap-3 flex-wrap">
        <span className="text-3xl md:text-4xl nds-num tabular-nums" data-testid="demo-clicks-this-week">{s ? s.this_week : "…"}</span>
        <span className="font-mono text-xs text-nex-muted" data-testid="demo-clicks-last-week">
          {s ? `${s.last_week} last week${diff ? ` · ${diff > 0 ? "+" : ""}${diff}` : ""}` : ""}
        </span>
      </div>
      <div className="mt-3 flex flex-wrap gap-2">
        {SOURCES.map(([k, label]) => (
          <span key={k} className="nds-pill" style={{ padding: "3px 8px", fontSize: "0.625rem" }} data-testid={`demo-clicks-source-${k}`}>
            {label}: {s ? s.by_source[k] : 0}
          </span>
        ))}
      </div>
    </div>
  );
}
